<template>
  <PageContainer title="Central de Notificações" data-testid="notifications-page">
    <Box color="bg-gray" data-testid="notifications-container">
      <Tabs ref="tabs" :options="['Todas', 'Notificações', 'Controle de versão', 'Não lidas', 'Lidas', 'Arquivadas']"
        data-testid="notifications-tabs">
        <NotificationsList slot="Todas" data-testid="tab-all" />
        <NotificationsList slot="Notificações" type="notification" data-testid="tab-notifications" />
        <NotificationsList slot="Controle de versão" type="version_control" data-testid="tab-version-control" />
        <NotificationsList slot="Não lidas" status="unread" data-testid="tab-unread" />
        <NotificationsList slot="Lidas" status="read" :show-read-button="false" data-testid="tab-read" />
        <NotificationsList slot="Arquivadas" status="archived" :show-read-button="false" data-testid="tab-archived" />
      </Tabs>
    </Box>
  </PageContainer>
</template>

<script>
import PageContainer from "core/PageContainer"
import Box from "core/Box"
import Tabs from "core/Tabs"
import NotificationsList from "./NotificationsList"

export default {
  name: "Notifications",
  components: {
    PageContainer,
    Box,
    Tabs,
    NotificationsList,
  },
  mounted() {
    if (this.$route.query && this.$route.query.tab) {
      const tab = this.$route.query.tab

      if (tab === 'notification') {
        this.$refs.tabs.setActive('Notificações')
      } else if (tab === 'version_control') {
        this.$refs.tabs.setActive('Controle de versão')
      }
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>